type ReadModelWithId = {
  id: string;
} | undefined | null

export function isReadModelExisting<T extends ReadModelWithId>(entity: T): entity is NonNullable<T> {
  return !!entity?.id;
}
